export const MOCK_IN_GRID_ASSETS = [
  {
    id: 1,
    options: {
      customVars: {
        position: null,
        size: null,
        cellsTall: 1,
        cellsWide: 1,
        row: 1,
        column: 1,
        // TODO: test against different assetPriority: 1 vs. assetPriority: 7,
      },
    },
  },
  {
    id: 2,
    options: {
      customVars: {
        position: null,
        size: null,
        cellsTall: 2,
        cellsWide: 1,
        row: 2,
        column: 3,
      },
    },
  },
  {
    id: 3,
    options: {
      customVars: {
        position: null,
        size: null,
        cellsTall: 1,
        cellsWide: 1,
        row: 2,
        column: 2,
      },
    },
  },
  {
    id: 4,
    imageFilename:
      'https://cms.justfab.cmsqa1.qa.techstyle.net/network_resources/asset_resources/qa/57772/17428456176811742833758714OneAcross-4.jpg',
    options: {
      customVars: {
        position: null,
        size: null,
        cellsTall: 2,
        cellsWide: 1,
        row: 3,
        column: 1,
      },
    },
  },
  {
    id: 5,
    options: {
      customVars: {
        position: null,
        size: null,
        cellsTall: 2,
        cellsWide: 2,
        row: 4,
        column: 2,
      },
    },
  },
  {
    id: 6,
    imageFilename:
      'https://cms.justfab.cmsqa1.qa.techstyle.net/network_resources/asset_resources/qa/57769/174286183493517428454435601742504600839TwoAcross.jpg',
    options: {
      customVars: {
        position: null,
        size: null,
        cellsTall: 1,
        cellsWide: 'full',
        row: 7,
        column: 2,
      },
    },
  },
  {
    id: 7,
    options: {
      customVars: {
        videoId: 1012571201,
        position: null,
        size: null,
        cellsTall: 1,
        cellsWide: 2,
        row: 8,
        column: 'left',
      },
    },
  },
  {
    id: 8,
    options: {
      customVars: {
        position: null,
        size: null,
        cellsTall: 2,
        cellsWide: 2,
        row: 9,
        column: 'right',
      },
    },
  },
];
